import React from "react";
import {
  Edit,
  SimpleForm,
  required,
} from "react-admin";
import { Typography, Divider } from '@mui/material';
import AdminEditableCreditInformation from '../components/AdminEditableCreditInformation';

// Function to ensure only credit data is processed
const transformCreditData = (data) => {
  // Clean undefined values from the data
  const cleanData = Object.fromEntries(
    Object.entries(data).filter(([_, value]) => value !== undefined)
  );
  
  // Ensure bankGroup is always COFIDIS
  cleanData.bankGroup = 'COFIDIS';
  
  return cleanData;
};

const SectionTitle = ({ title }) => (
  <>
    <Typography variant="h6" color="primary" gutterBottom sx={{ mt: 3, mb: 2 }}>
      {title}
    </Typography>
    <Divider sx={{ mb: 2 }} />
  </>
);

export const CofidisCaseEditCredits = (props) => {
  return (
    <Edit {...props} transform={transformCreditData} mutationMode="pessimistic" redirect="show">
      <SimpleForm>
        {/* Case Information Section */}
        <SectionTitle title="Información del Caso" />
        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
          Editando información de créditos para este caso.
        </Typography>

        {/* Credit Information Section — always use the full admin editor so
            every credit field is editable (cofidisCases is only edited in the
            admin view). */}
        <AdminEditableCreditInformation source="creditos" />
      </SimpleForm>
    </Edit>
  );
};
